import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DateQuestionComponent } from "src/app/common/question/date-question/date-question.component";
import { LongAnswerQuestionComponent } from "src/app/common/question/long-answer-question/long-answer-question.component";
import { RatingQuestionComponent } from "src/app/common/question/rating-question/rating-question.component";
import { ShortAnswerQuestionComponent } from "src/app/common/question/short-answer-question/short-answer-question.component";
import { SharedModules } from "src/app/shared.modules";
import { MultipleChoiceQuestionComponent } from "./multiple-choice-question/multiple-choice-question.component";
import { QuestionViewComponent } from "./question-view/question-view.component";
import { QuestionViewDirective } from "./question-view/question-view.directive";
// tslint:disable-next-line:max-line-length
import { CheckboxMultipleChoiceQuestionComponent } from "src/app/common/question/checkbox-multiple-choice-question/checkbox-multiple-choice-question.component";
import { TextBoxComponent } from "src/app/common/question/text-box/text-box.component";
import { AddressQuestionComponent } from "./address-question/address-question.component";
import { DropDownNumberQuestionComponent } from "./drop-down-number-question/drop-down-number-question.component";
import { MedicationMultipleInputQuestionItemComponent } from "./medication-multiple-input-question/medication-multiple-input-question-item/medication-multiple-input-question-item.component";
import { MedicationMultipleInputQuestionComponent } from "./medication-multiple-input-question/medication-multiple-input-question.component";
import { CustomSliderComponent } from "../custom-slider/custom-slider.component";
import { ButtonComponent } from "../button/button.component";
import { AngularSvgIconModule } from "angular-svg-icon";
import { ErrorDisplayComponent } from "../error-display/error-display.component";
@NgModule({
  declarations: [
    QuestionViewDirective,
    QuestionViewComponent,
    MultipleChoiceQuestionComponent,
    ShortAnswerQuestionComponent,
    LongAnswerQuestionComponent,
    RatingQuestionComponent,
    DateQuestionComponent,
    CheckboxMultipleChoiceQuestionComponent,
    TextBoxComponent,
    MedicationMultipleInputQuestionComponent,
    MedicationMultipleInputQuestionItemComponent,
    DropDownNumberQuestionComponent,
    AddressQuestionComponent,
  ],
  imports: [
    CommonModule,
    SharedModules,
    CustomSliderComponent,
    ButtonComponent,
    AngularSvgIconModule,
    ErrorDisplayComponent,
  ],
  exports: [
    QuestionViewDirective,
    QuestionViewComponent,
    MultipleChoiceQuestionComponent,
    ShortAnswerQuestionComponent,
    LongAnswerQuestionComponent,
    RatingQuestionComponent,
    DateQuestionComponent,
    CheckboxMultipleChoiceQuestionComponent,
    TextBoxComponent,
    MedicationMultipleInputQuestionComponent,
    DropDownNumberQuestionComponent,
    AddressQuestionComponent,
  ],
})
export class QuestionModule {}
